import React, { Fragment } from "react";
import PagesContainerTemplateController from "./controllers/PagesContainerController";
import PagesComponents from "../components/Pages";
import { Route } from "react-router-dom";
import BuilderContainer from "./BuilderContainer";
import useBuilderComponents from "../hooks/useBuilderComponents";
import { BuilderProvider } from "../../context/customize/builder/context";

const PagesContainer: React.FC = () => {
	const BuilderComponents = useBuilderComponents();

	return (
		<>
			<PagesContainerTemplateController>
				{PagesComponents.map((component, key) => {
					return (
						<Fragment key={`pages-${key}`}>
							<Route
								exact
								path={component.path}
								component={component.component}
							/>
						</Fragment>
					);
				})}
				<BuilderContainer>
					{BuilderComponents.map((component, key) => {
						return (
							<Fragment key={`customize-${key}`}>
								<BuilderProvider>
									<Route
										exact
										path={component.path}
										component={component.component}
									/>
								</BuilderProvider>
							</Fragment>
						);
					})}
				</BuilderContainer>
			</PagesContainerTemplateController>
		</>
	);
};

export default PagesContainer;
